import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Close } from '@material-ui/icons';
import { createStyles, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link: {
      textDecoration: 'none',
      display: 'inline-flex',
    },
    circle: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    circleOk: {
      backgroundColor: theme.palette.success.main,
    },
    circleError: {
      backgroundColor: theme.palette.error.main,
    },
    icon: {
      color: '#fff',
      fontSize: 16,
    },
  })
);

type StatusIconProps = {
  ok: boolean;
  to: string;
  ariaLabel?: string;
};

export const StatusIcon = ({ ok, to, ariaLabel }: StatusIconProps) => {
  const classes = useStyles();

  return (
    <Link to={to} className={classes.link} aria-label={ariaLabel}>
      <div className={`${classes.circle} ${ok ? classes.circleOk : classes.circleError}`}>
        {ok ? <Check className={classes.icon} /> : <Close className={classes.icon} />}
      </div>
    </Link>
  );
};
